/* tm-sticky-atc.js — PDP 移动端 sticky add-to-cart 控制
 * 行为：
 *  - 监听主 buy_buttons (.product-form__buttons) 可见性，不可见时显 sticky bar
 *  - sticky CTA click → 触发主 product-form 的 submit（不重建 form）
 *  - 主 variant 价格变化 → 同步 sticky 价格区
 *  - 仅 ≤749px viewport 启用（CSS 控制 display；JS 仅做行为绑定，桌面端也无副作用）
 * 不替换 Dawn product-form / variant picker JS；仅旁路触发。
 */
(function () {
  'use strict';

  function onReady(fn) {
    if (document.readyState !== 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    }
  }

  onReady(function () {
    var stickyEls = document.querySelectorAll('.tm-sticky-atc');
    if (!stickyEls.length) return;

    stickyEls.forEach(function (sticky) {
      var formId = sticky.getAttribute('data-form-id');
      if (!formId) return;

      var mainForm = document.getElementById(formId);
      var mainBuyButtons = mainForm
        ? mainForm.querySelector('.product-form__buttons') || mainForm
        : null;
      var stickyCta = sticky.querySelector('[data-tm-sticky-cta]');
      var priceWrap = sticky.querySelector('[data-tm-sticky-price]');

      // 1) 用 IntersectionObserver 监听主 buy_buttons 可见性
      if (mainBuyButtons && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                sticky.hidden = true;
                sticky.classList.remove('is-visible');
              } else {
                sticky.hidden = false;
                // 用 rAF 让 hidden 切到 false 后再加 class 触发 transition
                requestAnimationFrame(function () {
                  sticky.classList.add('is-visible');
                });
              }
            });
          },
          { rootMargin: '0px 0px -40px 0px', threshold: 0 }
        );
        io.observe(mainBuyButtons);
      } else {
        // 无 IO 兜底：始终显示
        sticky.hidden = false;
        sticky.classList.add('is-visible');
      }

      // 2) sticky CTA click → 触发主 form submit
      if (stickyCta && mainForm) {
        stickyCta.addEventListener('click', function (e) {
          e.preventDefault();
          // 优先用 form 内主 Add-to-cart 按钮（保持 Dawn 的 product-form custom-element 行为完整）
          var mainSubmit =
            mainForm.querySelector('button[type="submit"].product-form__submit') ||
            mainForm.querySelector('button[type="submit"]') ||
            mainForm.querySelector('[name="add"]');
          if (mainSubmit && !mainSubmit.disabled) {
            mainSubmit.click();
          } else if (typeof mainForm.requestSubmit === 'function') {
            mainForm.requestSubmit();
          } else {
            mainForm.submit();
          }
        });
      }

      // 3) 监听变体变化 → 同步 sticky 价格与可购状态
      // Dawn 在变体切换后会更新 .price 节点；我们读它的最新文本同步过来
      var productInfo = mainForm ? mainForm.closest('product-info, .product') : null;
      if (productInfo && priceWrap) {
        var sync = function () {
          var mainPrice = productInfo.querySelector('.price');
          if (!mainPrice) return;
          // 取主价（sale 优先 .price-item--sale，否则 .price-item--regular）
          var sale = mainPrice.querySelector('.price-item--sale:not(.price-item--last)');
          var regular = mainPrice.querySelector('.price-item--regular');
          var lastReg = mainPrice.querySelector('.price-item--last');
          var current = '';
          var was = '';
          if (mainPrice.classList.contains('price--on-sale') && sale && lastReg) {
            current = sale.textContent.trim();
            was = lastReg.textContent.trim();
          } else if (regular) {
            current = regular.textContent.trim();
          }
          if (current) {
            priceWrap.innerHTML =
              '<span class="tm-sticky-atc__price-regular">' + current + '</span>' +
              (was ? ' <s class="tm-sticky-atc__price-was">' + was + '</s>' : '');
          }
          // 同步可购状态
          if (stickyCta) {
            var soldOutEl = productInfo.querySelector('.product-form__submit[disabled], button[name="add"][disabled]');
            stickyCta.disabled = !!soldOutEl;
          }
        };

        // 监听 productInfo 子节点变动（variant change 后 Dawn 会 re-render 价格）
        var mo = new MutationObserver(function (muts) {
          // 节流：用 rAF
          if (sync._pending) return;
          sync._pending = true;
          requestAnimationFrame(function () {
            sync._pending = false;
            sync();
          });
        });
        var priceContainer = productInfo.querySelector('.price') || productInfo;
        mo.observe(priceContainer, { childList: true, subtree: true, characterData: true });
      }
    });
  });
})();
